import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MemberOverrideMessage } from './memberOverrideMessage';

type MemberServerErrorSummaryProps = {
  serverErrors: string[];
  isMember: boolean;
  onClickOverride: () => void;
  overridePermission: string;
};

export const MemberServerErrorSummary = (props: MemberServerErrorSummaryProps) => {
  const { serverErrors, isMember, onClickOverride, overridePermission } = props;
  const { t } = useTranslation(['member']);
  if (serverErrors.length > 0) {
    return (
      <Alert severity='error' variant='filled' sx={{ borderRadius: 0 }}>
        <AlertTitle sx={{ fontSize: '1.2rem' }}>{t('member:editMember.errorSummaryHeader')}</AlertTitle>
        <ul style={{ margin: 0, paddingLeft: 0 }}>
          {serverErrors.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        {!isMember && <MemberOverrideMessage permission={overridePermission} onClickOverride={onClickOverride} />}
      </Alert>
    );
  }
  return null;
};
